import * as C from 'actions/constants';

export const blankState = {
  list: [],
  savedFilter: {},
  meta: {},
  selectedFilter: '',
  loading: false,
};

const SavedFilterReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_REPORT_SUCCESS: {
      const { data: { report: { id } } } = action;
      return { ...state, savedFilter: {}, selectedFilter: localStorage.getItem(`savedFilter_${id}`) };
    }
    case C.LOAD_SAVED_FILTERS: {
      return { ...state, loading: true };
    }
    case C.LOAD_SAVED_FILTER:
    case C.CREATE_SAVED_FILTER:
    case C.DELETE_SAVED_FILTER: {
      return { ...state, loading: true };
    }
    case C.LOAD_SAVED_FILTERS_SUCCESS: {
      const { data, meta } = action;
      return {
        ...state,
        loading: false,
        list: data,
        meta,
      };
    }
    case C.LOAD_SAVED_FILTER_SUCCESS: {
      const { data: savedFilter } = action;
      return { ...state, loading: false, savedFilter };
    }
    case C.SELECT_SAVED_FILTER: {
      const { data: selectedFilter } = action;
      return { ...state, selectedFilter };
    }
    case C.CLOSE_REPORT:
    case C.CLEAR_SAVED_FILTER: {
      return { ...state, selectedFilter: '', savedFilter: {} };
    }
    case C.DELETE_SAVED_FILTER_SUCCESS:
    case C.CREATE_SAVED_FILTER_SUCCESS:
    case C.DELETE_SAVED_FILTER_ERROR:
    case C.CREATE_SAVED_FILTER_ERROR:
    case C.LOAD_SAVED_FILTER_ERROR:
    case C.LOAD_SAVED_FILTERS_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export default SavedFilterReducer;
